if (!customElements.get('watches-products')) {
  customElements.define('watches-products', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.animation !== 'true' || matchMedia('(prefers-reduced-motion:reduce)').matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      }, {threshold:.08});
      this.classList.add('is-ready');
      this.querySelectorAll('.wp__heading,.wp__tile').forEach(element => this.observer.observe(element));
      this.onFocus = event => event.target.closest('.wp__tile')?.classList.add('is-visible');
      this.addEventListener('focusin',this.onFocus);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('focusin',this.onFocus);
      this.classList.remove('is-ready');
    }
  });
}
